"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = void 0;
var ServiceType;
(function (ServiceType) {
    ServiceType[ServiceType["Electrical"] = 1] = "Electrical";
    ServiceType[ServiceType["HVAC"] = 2] = "HVAC";
    ServiceType[ServiceType["Plumbing"] = 3] = "Plumbing";
    ServiceType[ServiceType["Handyman"] = 4] = "Handyman";
    ServiceType[ServiceType["Landscape"] = 5] = "Landscape";
    ServiceType[ServiceType["PestControl"] = 6] = "PestControl";
    ServiceType[ServiceType["PoolMaintenance"] = 7] = "PoolMaintenance";
    ServiceType[ServiceType["Cleaning"] = 8] = "Cleaning";
    ServiceType[ServiceType["Fencing"] = 9] = "Fencing";
    ServiceType[ServiceType["Flooring"] = 10] = "Flooring";
    ServiceType[ServiceType["Hauling"] = 11] = "Hauling";
    ServiceType[ServiceType["HomeInspection"] = 12] = "HomeInspection";
    ServiceType[ServiceType["Locksmith"] = 13] = "Locksmith";
    ServiceType[ServiceType["Painting"] = 14] = "Painting";
    ServiceType[ServiceType["PowerWashing"] = 15] = "PowerWashing";
    ServiceType[ServiceType["Restoration"] = 16] = "Restoration";
    ServiceType[ServiceType["Roofing"] = 17] = "Roofing";
    ServiceType[ServiceType["SnowRemoval"] = 18] = "SnowRemoval";
    ServiceType[ServiceType["SmartHome"] = 19] = "SmartHome";
    ServiceType[ServiceType["Assembly"] = 20] = "Assembly";
    ServiceType[ServiceType["Appliance"] = 21] = "Appliance";
    ServiceType[ServiceType["Exterior"] = 22] = "Exterior";
    ServiceType[ServiceType["SmartHomeThermostat"] = 23] = "SmartHomeThermostat";
    ServiceType[ServiceType["SmartHomeDoor"] = 24] = "SmartHomeDoor";
    ServiceType[ServiceType["SmartHomeSecurity"] = 25] = "SmartHomeSecurity";
    ServiceType[ServiceType["SmartHomeEvCharger"] = 26] = "SmartHomeEvCharger";
    ServiceType[ServiceType["SmartHomeSensor"] = 27] = "SmartHomeSensor";
    ServiceType[ServiceType["SmartHomeLight"] = 28] = "SmartHomeLight";
    ServiceType[ServiceType["SmartHomeOther"] = 29] = "SmartHomeOther";
    ServiceType[ServiceType["SmartHomeAssistant"] = 30] = "SmartHomeAssistant";
    ServiceType[ServiceType["GarageDoor"] = 31] = "GarageDoor";
    ServiceType[ServiceType["Dispenser"] = 32] = "Dispenser";
    ServiceType[ServiceType["AboveGround"] = 33] = "AboveGround";
    ServiceType[ServiceType["Animals"] = 34] = "Animals";
    ServiceType[ServiceType["BasicElectrical"] = 35] = "BasicElectrical";
    ServiceType[ServiceType["BasicPlumbing"] = 36] = "BasicPlumbing";
    ServiceType[ServiceType["BoilersAndRadiator"] = 37] = "BoilersAndRadiator";
    ServiceType[ServiceType["Carpentry"] = 38] = "Carpentry";
    ServiceType[ServiceType["Carpet"] = 39] = "Carpet";
    ServiceType[ServiceType["CentralAir"] = 40] = "CentralAir";
    ServiceType[ServiceType["CentralAppliances"] = 41] = "CentralAppliances";
    ServiceType[ServiceType["CentralHeatingSystem"] = 42] = "CentralHeatingSystem";
    ServiceType[ServiceType["CentralVacuum"] = 43] = "CentralVacuum";
    ServiceType[ServiceType["FourPoint"] = 44] = "FourPoint";
    ServiceType[ServiceType["Door"] = 45] = "Door";
    ServiceType[ServiceType["Drains"] = 46] = "Drains";
    ServiceType[ServiceType["Driveway"] = 47] = "Driveway";
    ServiceType[ServiceType["Drywall"] = 48] = "Drywall";
    ServiceType[ServiceType["DuctsAndVents"] = 49] = "DuctsAndVents";
    ServiceType[ServiceType["ElectricWallAndRadiantHeatSystems"] = 50] = "ElectricWallAndRadiantHeatSystems";
    ServiceType[ServiceType["Environmental"] = 51] = "Environmental";
    ServiceType[ServiceType["ExteriorPaint"] = 52] = "ExteriorPaint";
    ServiceType[ServiceType["Facade"] = 53] = "Facade";
    ServiceType[ServiceType["FaucetsAndFixtures"] = 54] = "FaucetsAndFixtures";
    ServiceType[ServiceType["Freezer"] = 55] = "Freezer";
    ServiceType[ServiceType["FullHome"] = 56] = "FullHome";
    ServiceType[ServiceType["Generator"] = 57] = "Generator";
    ServiceType[ServiceType["Geothermal"] = 58] = "Geothermal";
    ServiceType[ServiceType["Gutters"] = 59] = "Gutters";
    ServiceType[ServiceType["Hardwood"] = 60] = "Hardwood";
    ServiceType[ServiceType["Home"] = 61] = "Home";
    ServiceType[ServiceType["HotTubs"] = 62] = "HotTubs";
    ServiceType[ServiceType["IceMaker"] = 63] = "IceMaker";
    ServiceType[ServiceType["InGround"] = 64] = "InGround";
    ServiceType[ServiceType["Insects"] = 65] = "Insects";
    ServiceType[ServiceType["Insulation"] = 66] = "Insulation";
    ServiceType[ServiceType["InteriorPaint"] = 67] = "InteriorPaint";
    ServiceType[ServiceType["LaminateVinyl"] = 68] = "LaminateVinyl";
    ServiceType[ServiceType["LawnCare"] = 69] = "LawnCare";
    ServiceType[ServiceType["LightingAndFans"] = 70] = "LightingAndFans";
    ServiceType[ServiceType["MoveInOutReport"] = 71] = "MoveInOutReport";
    ServiceType[ServiceType["Mulching"] = 72] = "Mulching";
    ServiceType[ServiceType["Opener"] = 73] = "Opener";
    ServiceType[ServiceType["OutletsAndSwitches"] = 74] = "OutletsAndSwitches";
    ServiceType[ServiceType["ParkingLot"] = 75] = "ParkingLot";
    ServiceType[ServiceType["Septic"] = 76] = "Septic";
    ServiceType[ServiceType["SprinklerSystem"] = 77] = "SprinklerSystem";
    ServiceType[ServiceType["Stone"] = 78] = "Stone";
    ServiceType[ServiceType["Storm"] = 79] = "Storm";
    ServiceType[ServiceType["Tile"] = 80] = "Tile";
    ServiceType[ServiceType["TreeTrimming"] = 81] = "TreeTrimming";
    ServiceType[ServiceType["Warranty"] = 82] = "Warranty";
    ServiceType[ServiceType["WaterMitigation"] = 83] = "WaterMitigation";
    ServiceType[ServiceType["WaterConditioning"] = 84] = "WaterConditioning";
    ServiceType[ServiceType["WaterSoftenersPurificationSystems"] = 85] = "WaterSoftenersPurificationSystems";
    ServiceType[ServiceType["WiringAndPanel"] = 86] = "WiringAndPanel";
    ServiceType[ServiceType["Tarping"] = 88] = "Tarping";
    ServiceType[ServiceType["EmergencyBoardUp"] = 89] = "EmergencyBoardUp";
    ServiceType[ServiceType["RestorationFire"] = 90] = "RestorationFire";
    ServiceType[ServiceType["RestorationWaterDamage"] = 91] = "RestorationWaterDamage";
    ServiceType[ServiceType["RemediationAsbestos"] = 92] = "RemediationAsbestos";
    ServiceType[ServiceType["RemediationMold"] = 93] = "RemediationMold";
    ServiceType[ServiceType["RemediationLead"] = 94] = "RemediationLead";
    ServiceType[ServiceType["ProductInstallation"] = 100] = "ProductInstallation";
    ServiceType[ServiceType["Dishwasher"] = 101] = "Dishwasher";
    ServiceType[ServiceType["Microwave"] = 102] = "Microwave";
    ServiceType[ServiceType["GarbageDisposal"] = 103] = "GarbageDisposal";
    ServiceType[ServiceType["TrashCompactor"] = 104] = "TrashCompactor";
    ServiceType[ServiceType["Refrigerator"] = 105] = "Refrigerator";
    ServiceType[ServiceType["Dryer"] = 106] = "Dryer";
    ServiceType[ServiceType["Washer"] = 107] = "Washer";
    ServiceType[ServiceType["OvenStoveRange"] = 108] = "OvenStoveRange";
    ServiceType[ServiceType["Pumps"] = 109] = "Pumps";
    ServiceType[ServiceType["WaterHeaters"] = 110] = "WaterHeaters";
    ServiceType[ServiceType["BasicHVAC"] = 111] = "BasicHVAC";
    ServiceType[ServiceType["Residential"] = 200] = "Residential";
    ServiceType[ServiceType["Commercial"] = 201] = "Commercial";
    ServiceType[ServiceType["GeneralContractor"] = 202] = "GeneralContractor";
    ServiceType[ServiceType["Remediation"] = 203] = "Remediation";
    ServiceType[ServiceType["BoardUpTarp"] = 204] = "BoardUpTarp";
    ServiceType[ServiceType["Cabinetry"] = 205] = "Cabinetry";
    ServiceType[ServiceType["Countertops"] = 206] = "Countertops";
    ServiceType[ServiceType["LeakDetection"] = 207] = "LeakDetection";
    ServiceType[ServiceType["Masonry"] = 208] = "Masonry";
    ServiceType[ServiceType["PoolEnclosures"] = 209] = "PoolEnclosures";
    ServiceType[ServiceType["TreeRemoval"] = 210] = "TreeRemoval";
    ServiceType[ServiceType["Siding"] = 211] = "Siding";
    ServiceType[ServiceType["ContentsPackOut"] = 212] = "ContentsPackOut";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
